const types = {
	SET_USER_TYPE: "SET_USER_TYPE",
	USER_LOGIN: "USER_LOGIN",
	GET_USER_PROFILE: "GET_USER_PROFILE",
	GET_PATIENT_HISTORY: "GET_PATIENT_HISTORY",
	USER_LOGOUT: "USER_LOGOUT",
};

export default types;
